import {VeterinarioRef} from "./Veterinario";
import firebase from "firebase/compat";
import {ModelControler, ModelErrorMap} from "../lib/ModelController";
import fb from "../lib/firebase";
import {BaseModel} from "./Core";

export type TipoFazenda = 'Leite' | 'Corte';
export type DesignacaoFazenda = 'Fazenda' | 'Sítio' | 'Chácara' | 'Rancho';
export const DesignacaoFazendaList = ['Fazenda', 'Sítio', 'Chácara', 'Rancho', 'Haras', 'Estância', 'Colônia',
  'Tambo', 'Leiteria', 'Confinamento'];

export interface FazendaObject extends BaseModel {
  owner: string;
  ativo?: boolean;
  transferido_de?: string;
  transferido_de_nome?: string;
  matriz: boolean;
  tipo: TipoFazenda[];
  // loja: LojaRef;
  designacao?: DesignacaoFazenda;
  nome: string;
  responsavel: 'Veterinário' | 'Proprietário' | 'Gerente';
  veterinario: VeterinarioRef[];
  veterinarios: string[]; // membership
  // proprietario: string;
  gerente: string;
  telefone: string;
  email: string;
  cidade: string;
  estado: string;
  latitude: string;
  longitude: string;
  tem_calendario_sanitario: boolean;

  sistema_producao: string[];       // corte
  sistema_producao_leite: string;   // leite

  // contadores internos nao editaveis
  quantidade_animais: number;
  producao_litros_dia: number;    // apenas leite

  // corte
  possui_estacao_monta: boolean;

  // ref key para Proprietario
  _proprietario: firebase.firestore.DocumentReference;
  _numEventos: number;
}

export function prepareFazenda(values:any): FazendaObject {
  // ajustar tipo
  const tipo: string[] = typeof values.tipo === 'string' ?
    [values.tipo] : values.tipo;

  // ajustar veterinario
  let veterinario: VeterinarioRef[] = [];
    if (Array.isArray(values.veterinario))
      veterinario = values.veterinario;
    else if (typeof values.veterinario === 'object')
      veterinario = [values.veterinario];

  return {
    ...values,
    veterinario,
    tipo,
  }
}

export class FazendaController extends ModelControler<FazendaObject> {
  onClean() {
    return new ModelErrorMap();
  }

  async preSave() {
    const instance = this.getInstance();
    if (this.isNew) {
      instance.owner = this.user.uid;
      instance._numEventos = 0;
    }

    return instance;
  }

  async onSave(values: FazendaObject) {
    if (this.isNew) {
      return fb.document.create('fazendas', values);
    } else {
      return fb.document.update(
        'fazendas',
        this.get('id'),
        values,
      );
    }
  }

  prepareInstance(values: any): FazendaObject {
    // ajustar tipo
    const tipo: TipoFazenda[] = typeof values.tipo === 'string' ? [values.tipo] : values.tipo;

    // ajustar veterinario
    let veterinario: VeterinarioRef[] = [];
    if (Array.isArray(values.veterinario))
      veterinario = values.veterinario;
    else if (typeof values.veterinario! === 'object')
      veterinario = [values.veterinario];

    return {
      ...values,
      veterinario,
      tipo,
    } as FazendaObject;
  }
}


export const getFazendaNomeCompleto = (fazenda: FazendaObject): string => {
  if (!fazenda)
    return '';

  const {designacao, nome} = fazenda;
  if (designacao && nome)
    return `${designacao} ${nome}`;
  else if (nome)
    return nome;
  else
    return '--na--';
}